export default "__VITE_ASSET__BOWyHhO9__"